import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';

@Component({
  selector: '',
  template: '',
})
export class MyTeamDetailsHandler extends BaseSearchComponent<HierarchyService> implements OnInit {
  agentId;
  agents;
  agentKeys;
  visibleDetailKeys: string[] = ['qtd', 'ytd', 'SubordinateList'];
  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.agentId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    super.ngOnInit();
    this.getSubOrdinateList();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'MyTeamDetails',
        link: '/search-my-team-details',
      },
      {
        id: 'UplineHierarchy',
        link: '/upline-hierarchy-details',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Profile',
        link: '/profile/:id',
      },
      {
        id: 'ProductionDetails',
        link: '/search-production-details/:id',
      },
      {
        id: 'CompensationEvaluation',
        link: '/home',
      },
      {
        id: 'BalanceDetails',
        link: '/search-balance-details/:id',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('uplineHierarchy');
    return header;
  }

  getSubOrdinateList() {
    this.service.getSubOrdinateList(this.agentId).subscribe((res) => {
      {
        let resData = JSON.parse(JSON.stringify(res));
        if (resData != undefined && resData.data != undefined && resData.data[0] != undefined) {
          this.agentKeys = Object.keys(resData.data[0]).filter(
            (key) => key !== 'agentImage' && key !== 'mtd' && !this.visibleDetailKeys.includes(key)
          );
        }
        this.agents = resData.data.map((agent) => ({
          ...agent,
          isSelected: false,
        }));
      }
    });
  }

  toggleDetails(agent) {
    agent.isSelected = !agent.isSelected;
  }
}
